import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useService from "../Hooks/useService";
import MeetingsWidget from "../Presentational/Widgets/MeetingsWidget";
import MeetingService from "../../Services/Meeting.service";
import { useVirtualizedApp } from "../Hooks/useVirtualizedApp";
const PAGE_SIZE = 5;
const MeetingsContainer = () => {
    const [offset, setOffset] = React.useState(0);
    const virtualizedAppContext = useVirtualizedApp();
    const [meetingState, loadMeetingState] = useService(MeetingService.getAdvisorMeetings);
    React.useEffect(() => {
        loadMeetingState({ max: PAGE_SIZE, offset });
    }, [offset, loadMeetingState]);
    return (_jsx(MeetingsWidget, { meetingState: meetingState, pageSize: PAGE_SIZE, refresh: () => {
            setOffset(0);
            loadMeetingState({ max: PAGE_SIZE, offset: 0 });
        }, offset: offset, setOffset: setOffset, shadow: virtualizedAppContext.name === "app" }));
};
export default MeetingsContainer;
